import { render, staticRenderFns } from "./PackageEvents.vue?vue&type=template&id=6f3cf4b3&scoped=true&"
import script from "./PackageEvents.vue?vue&type=script&lang=js&"
export * from "./PackageEvents.vue?vue&type=script&lang=js&"
import style0 from "./PackageEvents.vue?vue&type=style&index=0&id=6f3cf4b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3cf4b3",
  null
  
)

/* custom blocks */
import block0 from "./PackageEvents.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports